import {v4 as uuidv4} from 'uuid'
import {ajaxJsonCall} from '@freckle/student-entities/ts/common/helpers/ajax'
import {
  EchoError,
  FetchEchoError
} from '@freckle/student-entities/ts/common/helpers/ajax/helpers/errors/echo-error'
import CommonApiHelper from './common-api-helper'
import {appendQueryStringToRoute} from './routers/query-params'

// Re-export for backward compatibility
export {EchoError, FetchEchoError}

export function appendParams(
  urlString: string,
  params: {
    [x: string]: string | boolean | number
  }
): string {
  // The UrlSearchParams type isn't supported on iOS < 10
  const searchParams = []
  for (const [key, value] of Object.entries(params)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchParams.push(`${key}=${encodeURIComponent((value as any).toString())}`)
  }
  const url = new URL(urlString)
  const sep = url.search.trim() === '' ? '?' : '&'
  url.search += `${sep}${searchParams.join('&')}`
  return url.toString()
}

const newRequestEcho = () => uuidv4()

export async function genericFetchWithEcho(url: string, init?: RequestInit): Promise<Response> {
  const requestEcho = newRequestEcho()
  const urlWithEcho = appendQueryStringToRoute(removeXEcho(url), {'x-echo': requestEcho})
  const response = await fetch(urlWithEcho, init)
  const responseXEcho = response.headers.get('x-echo')
  if (
    responseXEcho !== null &&
    responseXEcho !== undefined &&
    requestEcho !== responseXEcho &&
    response.status !== 503 &&
    response.status !== 504
  ) {
    throw new FetchEchoError(
      `X-Echo expected "${requestEcho}", but found "${responseXEcho}"`,
      response
    )
  }
  return response
}

//If the outgoing route already has an x-echo query param, we need to replace it with the new one.
//Example usecase: pagination link header URLs provided by backend include x-echo's that should be
//replaced with new ones.
export const addXEchoHeader = (url: string): string =>
  appendParams(removeXEcho(url), {'x-echo': newRequestEcho()})

export function removeXEcho(urlString: string): string {
  const url = new URL(urlString)

  if (url.searchParams.has('x-echo')) {
    url.searchParams.delete('x-echo')
  }

  return url.toString()
}

export function checkStudentCookie(): Promise<void> {
  return ajaxJsonCall({
    url: CommonApiHelper.fancyPaths.v2.students.sessions(),
    method: 'GET'
  })
}
